import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  // Add logging to track authentication status changes
  // console.log("🔒 ProtectedRoute render:", {
  //   loading,
  //   isAuthenticated,
  //   userEmail: user?.email,
  //   hasUser: !!user
  // });

  // Show loading spinner while checking authentication
  if (loading) {
    // console.log("⏳ ProtectedRoute: Loading state");
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    // console.log("🚫 ProtectedRoute: Not authenticated, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  // Additional check: ensure user data exists
  if (!user) {
    // console.log("⚠️ ProtectedRoute: Authenticated but no user data, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  // Render children if authenticated and user data exists
  // console.log("✅ ProtectedRoute: Authenticated user found, rendering protected content");
  return children;
};

export default ProtectedRoute;
